import Vue, { ref } from 'vue'
import axios from 'axios'

let tables = [
  'customers',
  'suppliers',
  'accounts',
  'partners',
  'safes',
  'bankAccounts',
  'capitals',
  'stores',
  'products',
  'subscriptions',
  'materials',
  'pickupLocations',
  'employees',
  'manufacturingModels',
  'manufacturingModelProducts',
  'manufacturingModelMaterials',
  'pointOfSales',
  'paymentMethods',
  'callCenters',
  'paymentFees',
  'expenseSections',
  'incomeSections',
  'taxes',
  'discounts',
  'invoiceGroups',
  'sections',
  'units',
  'deliveries',
  'cities',
  'shippingAddresses',
  'marketers',
  'priceLists',
  'details',
  'productOptions',
  'productOptionItems',
  'productQuantities',
  'productPrices',
  'productUnits',
  'signatures',
  'invoiceStatus',
  'customerSections',
  'supplierSections',
  'unitsCoefficients',
  'users',
  'companies',
  'roles',
  'capitalsSections',
  'costCenters',
  'branches',
  'shortcuts',
  'shifts',
  'loyalPoints',
  'financialDependents',
  'pointOfSaleHalls',
  'operatingCycles'
]

// IndexedDB helper
const dbName = 'database'
const storeName = 'tablesData'
let db

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, 1)
    request.onerror = () => reject(request.error)
    request.onsuccess = () => {
      db = request.result
      resolve()
    }
    request.onupgradeneeded = (event) => {
      db = event.target.result
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName)
      }
    }
  })
}

function saveToDB(key, value) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], 'readwrite')
    const store = transaction.objectStore(storeName)
    const request = store.put(value, key)
    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}

function getAllFromDB() {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storeName], 'readonly')
    const store = transaction.objectStore(storeName)
    const request = store.getAllKeys()
    const data = {}
    request.onsuccess = async () => {
      const keys = request.result
      for (const key of keys) {
        const itemRequest = store.get(key)
        itemRequest.onsuccess = () => {
          data[key] = itemRequest.result
          if (Object.keys(data).length === keys.length) {
            resolve(data)
          }
        }
        itemRequest.onerror = () => reject(itemRequest.error)
      }
    }
    request.onerror = () => reject(request.error)
  })
}

export const database = ref([])

try {
  let storedDatabase = {}
  tables.forEach((table) => (storedDatabase[table] = []))
  Vue.prototype.$database = storedDatabase
  database.value = storedDatabase
} catch (e) {
  console.error('Error initializing database:', e)
}

openDB().then(async () => {
  try {
    const storedDatabase = await getAllFromDB()
    tables.forEach((table) => {
      if (typeof storedDatabase[table] === 'undefined') {
        storedDatabase[table] = []
      }
    })
    Vue.prototype.$database = storedDatabase
    database.value = storedDatabase
  } catch (e) {
    console.error('Error loading database:', e)
  }
})

// Update the database in local storage
Vue.prototype.$updateDatabase = function (data) {
  if (!navigator.onLine) return
  if (!data) data = tables
  data.forEach(async (item) => {
    if (!tables.includes(item)) return
    try {
      const response = await axios.get(Vue.prototype.$linkGenerator('/allData'), {
        params: { requiredData: [item] }
      })
      const key = Object.keys(response.data)[0]
      const value = response.data[key]

      // Update Vue observable
      let storedDatabase = Vue.prototype.$database
      storedDatabase[key] = value
      Vue.prototype.$database = storedDatabase
      database.value = storedDatabase
      // Store to IndexedDB
      await saveToDB(key, value)
    } catch (e) {
      console.error('Error updating database:', e)
    }
  })
}

Vue.prototype.$updateDatabaseSync = async function (data) {
  if (!navigator.onLine) return
  if (!data) data = tables
  for (const item of data) {
    if (!tables.includes(item)) return
    try {
      const response = await axios.get(Vue.prototype.$linkGenerator('/allData'), {
        params: { requiredData: [item] }
      })
      const key = Object.keys(response.data)[0]
      const value = response.data[key]

      // Update Vue observable
      let storedDatabase = Vue.prototype.$database
      storedDatabase[key] = value
      Vue.prototype.$database = storedDatabase
      database.value = storedDatabase
      // Store to IndexedDB
      await saveToDB(key, value)
    } catch (e) {
      console.error('Error updating database:', e)
    }
  }
}

Vue.prototype.$saveLocalDatabase = function () {
  try {
    let database = Vue.prototype.$database
    // Save to IndexedDB
    for (const table of tables) {
      saveToDB(table, database[table])
    }
  } catch (error) {
    console.error('An error occurred while saving to localStorage:', error)
  }
}
